import { StorePagination } from "../../../../DashboardPagination"
import { userActions } from "../../../../../store/user-slice"

const Pagination = ({ index }) => {
    return <StorePagination index={index} sliceName="user" actions={userActions} label="Benutzer Seitennavigation" />
}

export default Pagination
